<template>
  <div>
    <generic-container
      :title="$t('report viewer') + ' | ' + rpt.name"
      icon="line chart"
      :header_buttons="header_buttons"
    >
      <div class="ui dividing header">{{ $t("report setup") }}</div>
      <div
        data-step="1"
        ref="input_step"
        v-html="rpt.setup.input_screen_html"
      ></div>
      <div class="ui dividing header">{{ $t("report result") }}</div>
      <div data-step="2" id="result_step" ref="result_step"></div>
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  // stringify,
  loadDataTablesLibraries,
  error_toast,
} from "@/utils";
import { groupBy, uniq } from "lodash";
import GenericContainer from "@/components/GenericContainer";
import Chart from "chart.js";
import Vue from "vue";
import moment from "moment";
import "datatables.net";
import { v4 } from "uuid";
// require("datatables.net-buttons"); //(window, window.jQuery);
// require("datatables.net-buttons/js/buttons.html5"); // (window, window.jQuery);
// require("datatables.net-buttons/js/buttons.print"); // (window, window.jQuery);
// require("datatables.net-buttons/js/dataTables.buttons")(window, window.jQuery);
// require("datatables.net-buttons-se")(window, window.jQuery);
// import "datatables.net-se";

export default {
  name: "ReportViewer",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      rpt: { setup: {} },
      step: 1,
      input_vue: undefined,
      result_vue: undefined,
      header_buttons: [
        { icon: "left arrow", tooltip: this.$t("back"), click: this.back },
      ],
    };
  },
  computed: {},
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
  created() {
    let vm = this;
    if (this.$route.query.i) {
      local_api(vm, "post", "/report/do-get", {
        i: vm.$route.query.i,
      })
        .then((s) => {
          vm.rpt = s;

          setTimeout(() => {
            // let inputMixin = {};
            let mixin = {};
            try {
              if (s && s.setup && s.setup.input_screen_js)
                eval(`mixin = ${s.setup.input_screen_js}`);
            } catch (ex) {
              console.error(ex);
            }
            // try {
            //   // let mixin = undefined;
            //   let mixin = {};
            //   if (s && s.setup) eval(s.setup.input_screen_js);
            //   if (mixin) inputMixin = mixin;
            //   mixin = undefined;
            // } catch (err) {
            //   vm.$alertify.error(err);
            // }
            // eslint-disable-next-line no-unused-vars
            let inputVue = new Vue({
              mixins: [mixin],
              filters: filters,
              el: vm.$refs.input_step,
              methods: {
                groupBy: groupBy,
                submit: function() {
                  let _v = this;
                  window
                    .jQuery("#result_step")
                    .html(s.setup.result_screen_html);
                  local_api(vm, "post", "/report/do-execute", {
                    i: vm.rpt.uuid,
                    d: _v.$data,
                  })
                    // eslint-disable-next-line no-unused-vars
                    .then((result) => {
                      let rmixin = {};
                      try {
                        if (s && s.setup && s.setup.result_screen_js)
                          eval(`rmixin = ${s.setup.result_screen_js}`);
                      } catch (ex) {
                        console.error(ex);
                      }

                      // let resultMixin = {};
                      // try {
                      //   let mixin1 = undefined;
                      //   // vm.setup.result_screen_html = s.setup.result_screen_html;
                      //   if (s && s.setup) eval(s.setup.result_screen_js);
                      //   if (mixin1 != undefined) {
                      //     resultMixin = mixin1;
                      //   }
                      // } catch (err) {
                      //   vm.$alertify.error(err);
                      // }
                      // return { resultMixin, result };
                      return { rmixin, result };
                    })
                    .then((r) => {
                      // eslint-disable-next-line no-unused-vars
                      let resultVue = new Vue({
                        mixins: [r.rmixin],
                        filters: filters,
                        data: function() {
                          return {
                            result: r.result,
                          };
                        },
                        methods: {
                          groupBy: groupBy,
                          uniq: uniq,
                          Chart: Chart,
                          moment: moment,
                          v4: v4,
                          dynamicColors: function() {
                            var r = Math.floor(Math.random() * 255);
                            var g = Math.floor(Math.random() * 255);
                            var b = Math.floor(Math.random() * 255);
                            return "rgb(" + r + "," + g + "," + b + ")";
                          },
                        },
                        el: "#result_step",
                      });
                      vm.result_vue = resultVue;
                    })
                    .catch((err) => {
                      console.error(err);
                      error_toast(err);
                    });
                },
              },
            });
            vm.input_vue = inputVue;
          }, 200);
        })
        .catch((err) => {
          error_toast(err);
        });
    }
  },
  mounted() {
    if (!this.$route.query.i) this.$router.push({ name: "ReportIndex" });

    loadDataTablesLibraries();
  },
  watch: {},
};
</script>
